// Authentication analytics events

export const authEvents = {
  signupStarted: (source: string) => ({
    event: 'auth_signup_started',
    properties: {
      source,
      referrer: typeof document !== 'undefined' ? document.referrer : undefined,
    },
  }),

  signupCompleted: (method: 'email' | 'google' | 'magic_link') => ({
    event: 'auth_signup_completed',
    properties: {
      method,
    },
  }),

  signupFailed: (error: string, method: string) => ({
    event: 'auth_signup_failed',
    properties: {
      error_type: categorizeAuthError(error),
      error_message: error,
      method,
    },
  }),

  loginStarted: (method: string) => ({
    event: 'auth_login_started',
    properties: {
      method,
    },
  }),

  loginCompleted: (method: string) => ({
    event: 'auth_login_completed',
    properties: {
      method,
    },
  }),

  loginFailed: (error: string, method: string) => ({
    event: 'auth_login_failed',
    properties: {
      error_type: categorizeAuthError(error),
      error_message: error,
      method,
    },
  }),

  logoutCompleted: () => ({
    event: 'auth_logout_completed',
    properties: {},
  }),

  mfaEnabled: (method: 'totp' | 'sms') => ({
    event: 'auth_mfa_enabled',
    properties: { method },
  }),

  mfaVerified: () => ({
    event: 'auth_mfa_verified',
    properties: {},
  }),

  mfaFailed: (error: string) => ({
    event: 'auth_mfa_failed',
    properties: {
      error_message: error,
    },
  }),

  passwordResetRequested: () => ({
    event: 'auth_password_reset_requested',
    properties: {},
  }),

  passwordResetCompleted: () => ({
    event: 'auth_password_reset_completed',
    properties: {},
  }),

  sessionExpired: () => ({
    event: 'auth_session_expired',
    properties: {},
  }),
};

function categorizeAuthError(error: string): string {
  const lowerError = error.toLowerCase();
  if (lowerError.includes('invalid') || lowerError.includes('incorrect')) return 'invalid_credentials';
  if (lowerError.includes('email') && lowerError.includes('exist')) return 'email_exists';
  if (lowerError.includes('not found')) return 'user_not_found';
  if (lowerError.includes('rate') || lowerError.includes('limit')) return 'rate_limited';
  if (lowerError.includes('network') || lowerError.includes('connection')) return 'network_error';
  if (lowerError.includes('verify') || lowerError.includes('confirm')) return 'verification_required';
  return 'unknown';
}

export type AuthEvent = ReturnType<typeof authEvents[keyof typeof authEvents]>;
